import { ProductVariants } from '../types/theme';
import { headingSizes, HeadingSizesVariantsType } from './components/headings';

/** The Font Size variants. */
export type FontSizeVariantsType =
  | 'fs8'
  | 'fs10'
  | 'fs12'
  | 'fs16'
  | 'fs20'
  | 'fs25'
  | 'fs31'
  | 'fs39'
  | 'fs49'
  | 'fs61'
  | 'fs76'
  | 'fs95'
  | 'fs119';
/** The Font Size aliases variants. @returns `number` */
export type FontSizeAliases = Record<FontSizeVariantsType, number>;
/** The Font Size variants aliases. */
export type FontSizes = number[] & Partial<FontSizeAliases>;
/** The Font Size & Heading Size aliases. */
export type FontSizesHeadingSizesVariantsType = FontSizes & HeadingSizesVariantsType;
/** The Font Size variants object for all sites. */
export type FontSizeVariants = FontSizesHeadingSizesVariantsType & ProductVariants<FontSizesHeadingSizesVariantsType>;
const baseFontSizes: FontSizes = [
  8,
  10.2,
  12.8,
  16,
  20,
  25,
  31.3,
  39.1,
  48.8,
  61,
  76.3,
  95.4,
  119.2
];

export const fontSizeAliases: FontSizeAliases = {
  /** @returns `8` */
  fs8: baseFontSizes[0],
  /** @returns `10.2` */
  fs10: baseFontSizes[1],
  /** @returns `12.8` */
  fs12: baseFontSizes[2],
  /** @returns `16` */
  fs16: baseFontSizes[3],
  /** @returns `20` */
  fs20: baseFontSizes[4],
  /** @returns `25` */
  fs25: baseFontSizes[5],
  /** @returns `31.3` */
  fs31: baseFontSizes[6],
  /** @returns `39.1` */
  fs39: baseFontSizes[7],
  /** @returns `48.8` */
  fs49: baseFontSizes[8],
  /** @returns `61` */
  fs61: baseFontSizes[9],
  /** @returns `76.3` */
  fs76: baseFontSizes[10],
  /** @returns `95.4` */
  fs95: baseFontSizes[11],
  /** @returns `119.2` */
  fs119: baseFontSizes[12]
};

Object.keys(fontSizeAliases).forEach(fontSize => {
  const baseFontSizeKey = fontSize as FontSizeVariantsType;

  baseFontSizes[baseFontSizeKey] = fontSizeAliases[baseFontSizeKey];
});

export const fontSizeVariants = Object.keys(fontSizeAliases) as FontSizeVariantsType[];

const allFontSizes = { ...baseFontSizes, ...headingSizes };
const fontSizes: FontSizeVariants = {
  ...allFontSizes,
  products: {
    chart: allFontSizes,
    chartblog: allFontSizes,
    co: allFontSizes,
    edu: allFontSizes,
    scale: allFontSizes,
    spark: allFontSizes
  }
};

export default fontSizes;
